// ScrollHintPill — pastilla flotante "↓ bajá que hay más" (Sub-fase 4.5, tienda v5).
// Aparece cuando el usuario está arriba de todo (scrollY < 120) Y la página tiene contenido
// suficiente para scrollear (scrollHeight > innerHeight * 1.5). Se desvanece al scrollear y
// vuelve al subir. Fixed bottom-center, por encima del MiniBar. aria-hidden (decorativa).
// Self-contained: <style> + clases .tv5-shp-*. Respeta prefers-reduced-motion (sin bounce).
import { useEffect, useState } from 'react';

export function ScrollHintPill() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      const hayScroll = document.documentElement.scrollHeight > window.innerHeight * 1.5;
      setVisible(hayScroll && window.scrollY < 120);
    };
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    // Recheck tras montar (por si el contenido carga async y cambia la altura).
    const t = setTimeout(check, 1200);
    return () => {
      clearTimeout(t);
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);

  return (
    <div className={'tv5-shp' + (visible ? ' visible' : '')} aria-hidden="true">
      <style>{SHP_CSS}</style>
      <span className="tv5-shp-txt">bajá que hay más</span>
      <svg className="tv5-shp-chev" width="14" height="9" viewBox="0 0 14 9" fill="none" aria-hidden="true">
        <path d="M1 1l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}

const SHP_CSS = `
.tv5-shp {
  position:fixed; left:50%; bottom:calc(140px + env(safe-area-inset-bottom,0px));
  transform:translateX(-50%) translateY(8px); z-index:75;
  display:inline-flex; align-items:center; gap:8px; padding:8px 15px; border-radius:999px;
  background:rgba(10,20,36,0.78); backdrop-filter:blur(12px); -webkit-backdrop-filter:blur(12px);
  border:1px solid rgba(0,168,181,0.4); color:#F8F6F1;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif; font-size:12px; font-weight:700;
  box-shadow:0 8px 24px rgba(0,0,0,0.4); white-space:nowrap;
  opacity:0; pointer-events:none; transition:opacity 0.35s ease, transform 0.35s ease;
}
.tv5-shp.visible { opacity:1; transform:translateX(-50%) translateY(0); }
.tv5-shp-chev { color:#00A8B5; animation:tv5ShpBounce 2s ease-in-out infinite; }
@keyframes tv5ShpBounce { 0%,100% { transform:translateY(0); } 50% { transform:translateY(3px); } }
@media (min-width:900px){ .tv5-shp { bottom:96px; } }
@media (prefers-reduced-motion:reduce){ .tv5-shp-chev { animation:none; } .tv5-shp { transition:opacity 0.2s; } }
`;
